export const types = {
    DEFAULT: 'default',
    STATISTIC: 'statistic',
    TEMPLATE: 'template',
};
